import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import QuizGenerationConfigPanel from './QuizGenerationConfigPanel';
import SettingsToolbar from '../../components/settings/SettingsToolbar';
import language from '../../variables/language';
import '../../css/quiz-generation-config.css';

export default function QuizGenerationConfig() {
  const t = language[language.lang].quizGenerationConfigPage;

  return (
    <Layout>
      <SettingsToolbar />
      <PageHeader name={t.title} />
      <main className="main-block">
        <div className="main-content txt-c">
          <QuizGenerationConfigPanel />
        </div>
      </main>
    </Layout>
  );
}
